import { Layout, Typography } from 'antd';
import { AppRoutes } from 'helpers/app.routes';
import { titleHeaderSelector } from 'modules/common/selectors';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'utils/customHooks';

const { Header } = Layout;
const { Title } = Typography;

const HeaderCommon: FC<any> = () => {
  const { t } = useTranslation();
  const location = useLocation() as any;
  const { pathname } = location;
  const titleHeader = useAppSelector(titleHeaderSelector);

  const HEADER_TITLE: any = {
    [AppRoutes.main]: t('title_header.cargo_trace_search'),
    [AppRoutes.customsClearanceRequestSearch]: t('title_header.customs_clearance_request_search'),
    [AppRoutes.customsClearanceRequestRegisterSearch]: t('title_header.customs_clearance_request_add'),
    [AppRoutes.customsClearanceRequestExportSearch]: t('title_header.customs_clearance_request_search_export'),
    [AppRoutes.customsClearanceRequestExportRegisterSearch]: t('title_header.customs_clearance_request_add_export'),
    [AppRoutes.deliveryDestMaster]: t('title_header.delivery_dest_master'),
    [AppRoutes.reportBundleShipStatus]: t('title_header.ship_status'),
    [AppRoutes.reportBundleTraceSearch]: t('title_header.bl_info'),
    [AppRoutes.reportBundleTraceExportSearch]: t('title_header.bl_info_export'),
    [AppRoutes.outputReport]: t('title_header.report_output'),
    [AppRoutes.displayItem]: t('title_header.display_item_master'),
    [AppRoutes.reportBundleShipUpload]: t('title_header.ship_movement_upload'),
    [AppRoutes.shipMovementSearch]: t('title_header.ship_movement_search'),
    [AppRoutes.cargoInformationSearch]: t('title_header.cargo_trace_search'),
    [AppRoutes.cargoInformationExportSearch]: t('title_header.cargo_trace_search_export'),
    [AppRoutes.userMaintance]: t('title_header.user_master'),
    [AppRoutes.userMaintanceAddAction]: t('title_header.add_user_master'),
    [AppRoutes.accountMaster]: t('title_header.account_master'),
    [AppRoutes.hblStatus]: t('title_header.hbl_status'),
    [AppRoutes.hblStatusInfoUpload]: t('title_header.portcast_mbl_upload'),
    [AppRoutes.containerStatus]: t('title_header.container_status'),
    [AppRoutes.accountGrMaster]: t('title_header.account_group_master'),
    [AppRoutes.portMaster]: t('title_header.port_master'),
    [AppRoutes.generalMaster]: t('title_header.general_master'),
    [AppRoutes.searchPattern]: t('title_header.search_pattern'),
    [AppRoutes.documentApploval]: t('title_header.document_approval'),
    [AppRoutes.chatroom]: t('title_header.chatroom'),
    [AppRoutes.menuAuthorityMaster]: t('title_header.menu_authority_master'),
    [AppRoutes.aitGrMaster]: t('title_header.ait_group_master'),
    [AppRoutes.statusMaster]: t('title_header.status_master'),
    [AppRoutes.aitGrMaster]: t('title_header.ait_group_master'),
    [AppRoutes.notificationInformation]: t('title_header.notification_search'),
    [AppRoutes.notificationSetting]: t('title_header.notification_setting'),
  };

  const HEADER_TITLE_DYNAMIC: any = {
    [AppRoutes.preAlert]: t('title_header.pre_alert'),
    [AppRoutes.preAlertExport]: t('title_header.pre_alert_export'),
    [AppRoutes.displayItem]: t('title_header.display_item_master'),
    [AppRoutes.customsClearanceRequestInfo]: t('title_header.customs_clearance_request_info'),
  };

  const getHeaderDynamic = (pathname: string) => {
    const arrayHeaderTitleDynamic = Object.keys(HEADER_TITLE_DYNAMIC);
    let title;
    arrayHeaderTitleDynamic.forEach((item: any) => {
      if (pathname.includes(item)) {
        title = HEADER_TITLE_DYNAMIC[item];
      }
      if (titleHeader) {
        title = titleHeader;
      }
    });
    return title;
  };

  return (
    <Header
      className={
        [AppRoutes.main].includes(pathname) || pathname.includes(AppRoutes.cargoInformationSearch)
          ? 'header header-cargo-trace'
          : pathname.includes(AppRoutes.customsClearance)
          ? 'header header-cust-clear-req'
          : 'header'
      }
    >
      <Title className="header__title">{HEADER_TITLE?.[pathname] || getHeaderDynamic(pathname)}</Title>
    </Header>
  );
};
export default HeaderCommon;
